import { FC, useEffect } from "react";
import { useStore } from "../config/store";

export const Theory = () => {
  const { theory, getTheory } = useStore();

  useEffect(() => {
    if (!theory) {
      getTheory();
    }
  }, [theory]);

  return <div className="content">{theory}</div>;
};
